import type {RowData} from '@tanstack/react-table';
import {z} from 'zod';

export const createResponseSchema = <RowData>() =>
  z.object({
    data: z
      .object({
        items: z.array(z.custom<RowData>()),
        offset: z.number().optional(),
        limit: z.number().optional(),
        total: z.number(),
        has_more: z.boolean().optional(),
      })
      .optional(),
  });

export type SearchResponse<TData extends RowData = RowData> = z.infer<ReturnType<typeof createResponseSchema<TData>>>;

export interface SearchConfig {
  defaultSearch?: string | null;
  debounce?: number;
  pageSize?: number;
  checkIsEmpty?: <TData extends SearchResponse = SearchResponse>(data: Array<TData> | undefined) => boolean;
  checkIsReachingEnd?: <TData extends SearchResponse = SearchResponse>(
    data: Array<TData> | undefined,
    isEmpty: boolean,
  ) => boolean;
  checkIsLoadingMore?: <TData extends SearchResponse = SearchResponse>(
    isLoading: boolean,
    data: Array<TData> | undefined,
    size: number,
  ) => boolean;
  checkIsRefreshing?: <TData extends SearchResponse = SearchResponse>(
    isValidating: boolean,
    data: Array<TData> | undefined,
    size: number,
  ) => boolean;
}

export type FetcherArgs = [
  string | null,
  {
    pageIndex: number;
    pageSize: number;
    offset: number;
    search: string | null;
  },
];

export type SearchFetcher<TData extends RowData, TResponse extends SearchResponse<TData> = SearchResponse<TData>> = (
  ...args: FetcherArgs
) => Promise<TResponse>;
